import * as THREE from "three";
import SimplexNoise from "./simplex-noise";
import { GetSettings } from "./Settings";

exports.Unify = function(unify) {
  this.unify_id = "terrain";
  let settings = GetSettings();
  let size = settings.terrainSize;
  let simplex = new SimplexNoise(16);
  let simplex1 = new SimplexNoise(64);

  // Different terrain materials:
  let terrainMat1 = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    wireframe: true
  });

  var terrainMat2 = new THREE.MeshBasicMaterial({
    color: 0x000000,
    opacity: 0
  });

  var horizonMat = new THREE.MeshStandardMaterial({
    color: 0x281d38,
    wireframe: false
  });

  // Apply noise to vertices of geometry
  function applyTerrainNoise(size, terrain) {
    for (let i = 0; i < size; i++) {
      for (var j = 0; j < size; j++) {
        terrain.geometry.vertices[i * size + j].z =
          simplex.noise2D(i / 50, j / 50) * 3 +
          simplex.noise2D(i / 50, j / 50) * 0.5 +
          simplex1.noise2D(i / 20, j / 20) * 2;
      }
    }
    terrain.geometry.computeFaceNormals();
    terrain.geometry.computeVertexNormals();
  }

  const addTerrain = (size, mat, name) => {
    let terrainGeo = new THREE.PlaneGeometry(size, size, size - 1, size - 1);

    let terrain = new THREE.Mesh(terrainGeo, mat);
    applyTerrainNoise(size, terrain);
    unify.scene.add(terrain);
    terrain.name = name;
    unify.addNewAsset(name, terrain);
    return terrain;
  };

  const terrain1 = new addTerrain(size, terrainMat1, "terrain");
  terrain1.position.set(0, 0, 0);
  terrain1.rotation.set(-Math.PI / 2, 0, 0);

  const terrain2 = new addTerrain(size, terrainMat2, "terrain_mask");
  terrain2.position.set(0, -0.0075, 0);
  terrain2.rotation.set(-Math.PI / 2, 0, 0);

  // Creating horizon terrain
  const createHorizon = mat => {
    let horizonGeo = new THREE.CircleBufferGeometry(250, 100);

    let horizon = new THREE.Mesh(horizonGeo, mat);

    horizon.position.set(0, -8, 0);
    horizon.rotateX(-Math.PI / 2);
    unify.scene.add(horizon);

    const applyHorizonNoise = groundNoiseResolution => {
      for (let i = 0; i < horizonGeo.attributes.position.count; i++) {
        let vertVector = new THREE.Vector3(
          horizonGeo.attributes.position.array[i * 3],
          horizonGeo.attributes.position.array[i * 3 + 1],
          horizonGeo.attributes.position.array[i * 3 + 2]
        );
        let normVector = new THREE.Vector3(
          horizonGeo.attributes.normal.array[i * 3],
          horizonGeo.attributes.normal.array[i * 3 + 1],
          horizonGeo.attributes.normal.array[i * 3 + 2]
        );

        normVector.multiplyScalar(
          simplex.noise3D(
            vertVector.x / groundNoiseResolution,
            vertVector.y / groundNoiseResolution,
            vertVector.z / groundNoiseResolution
          ) * 10
        );
        vertVector.add(normVector);

        horizonGeo.attributes.position.array[i * 3] = vertVector.x;
        horizonGeo.attributes.position.array[i * 3 + 1] = vertVector.y;
        horizonGeo.attributes.position.array[i * 3 + 2] = vertVector.z;
      }
      // recalculate the normals
      horizon.geometry.computeFaceNormals();
      horizon.geometry.computeVertexNormals();
    };

    applyHorizonNoise(30);
  };

  const horizon = new createHorizon(horizonMat);

  // return world Y value at terrain X,Z
  this.getTerrainHeight = (worldX, worldZ) => {
    let tX = clamp(Math.round(worldX + size * 0.5), 0, size - 1);
    let tZ = clamp(Math.round(worldZ + size * 0.5), 0, size - 1);
    return terrain1.geometry.vertices[tZ * size + tX].z;
  };

  // return normal at terrain1 X, Z
  this.getTerrainNormal = (worldX, worldZ) => {
    let tX = clamp(Math.round(worldX + size * 0.5), 0, size - 1);
    let tZ = clamp(Math.round(worldZ + size * 0.5), 0, size - 1);
    //let normal = new THREE.Vector3();
    return terrain1.geometry.faces[tZ * size + tX].normal;
  };

  // set the color of the terrain1
  this.setColor = color => {
    terrain1.material.color.setHex(color);
  };

  function clamp(val, min, max) {
    return Math.min(Math.max(min, val), max);
  }

  let terrainFlasher = null;
  const flashTerrainColor = () => {
    if (terrainFlasher != null) clearInterval(terrainFlasher);
    terrainFlasher = setInterval(terrainColorToggle, 500);
  };

  // color toggle
  let colorState = false;
  const terrainColorToggle = () => {
    if (colorState) {
      this.setColor(settings.terrainColors[worldState]);
      colorState = !colorState;
    } else {
      this.setColor(0xffffff);
      colorState = !colorState;
    }
  };

  let worldState;
  const setState = state => {
    worldState = state;
    switch (state) {
      case -1:
        break;
      case 0:
        clearInterval(terrainFlasher);
        this.setColor(settings.terrainColors[state]);
        break;
      case 1:
        flashTerrainColor();

        break;
      case 2:
        clearInterval(terrainFlasher);
        this.setColor(settings.terrainColors[state]);
        break;
    }
  };
  this.awake = () => {
    // subscribe gameLogic world state event
    unify.modules.gameLogic.addEvent_WorldState(setState);
  };
};
